'use client';

import { HomepagePostCardsQueryResult } from '@app/sanity.types';
import { BlogCard } from '@components/BlogCard';
import { Button } from 'antd';
import { useKeenSlider } from 'keen-slider/react';
import { ArrowLeft, ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { FC, useState } from 'react';
import styles from './BlogSection.module.scss';

interface Props {
  posts: HomepagePostCardsQueryResult;
}

const BlogSectionCarousel: FC<Props> = ({ posts }) => {
  const [_currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const [ref, instanceRef] = useKeenSlider<HTMLDivElement>({
    slides: {
      perView: 1,
      spacing: 0,
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
    breakpoints: {
      '(min-width: 768px)': {
        slides: { perView: 2, spacing: 5 },
      },
      '(min-width: 1200px)': {
        slides: { perView: 3, spacing: 10 },
      },
    },
  });

  return (
    <div className={styles.carouselWrapper}>
      {loaded && !!instanceRef.current && (
        <ul className={styles.actionsNav}>
          <li>
            <Button
              shape="circle"
              className={`${styles.itemNavArrow} ${styles.itemNavArrowLeft}`}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                instanceRef.current?.prev();
              }}
              icon={<ChevronLeft />}
            />
          </li>
          <li>
            <Button
              shape="circle"
              className={`${styles.itemNavArrow} ${styles.itemNavArrowRight}`}
              icon={<ChevronRight />}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                instanceRef.current?.next();
              }}
            />
          </li>
        </ul>
      )}
      <div ref={ref} className="keen-slider">
        {posts.map((post) => (
          <div className="keen-slider__slide" key={post._id}>
            <BlogCard post={post} />
          </div>
        ))}
      </div>
    </div>
  );
};

export { BlogSectionCarousel };
